import { inject, Injectable } from "@angular/core";
import { RoleService } from "./role.service";
import { ProfileService } from "./profile.service";
import { AccountRegistrationApiService } from "./account-registration-api.service";
import { Role } from "../interfaces/role.interface";
import { RegistrationApiService } from "./registration-api.service";
import { UpdateFormRequest } from "../interfaces/forms/register-form.interface";
import { AccountContactUpdate } from "../interfaces/account-contact-update.interface";
import { AccountContactAdd } from "../interfaces/account-contact-add.interface";

@Injectable({
  providedIn: 'root',
})
export class RegistrationDetailsService {
  adminRegistrationApiService = inject(RegistrationApiService);
  accountRegistrationApiService = inject(AccountRegistrationApiService);
  roleService = inject(RoleService);
  profileService = inject(ProfileService);

  getRegistrationDetails$(accountId: number, includeInactiveContacts = false) {
    switch (this.roleService.role) {
      case Role.Admin:
        return this.adminRegistrationApiService.getRegistrationDetails$(accountId, includeInactiveContacts);
      case Role.PaOrMsp:
      case Role.Sido:
        return this.accountRegistrationApiService.getRegistrationDetails$(accountId, includeInactiveContacts);
    }
  }

  updateRegistrationDetails$(data: UpdateFormRequest) {
    switch (this.roleService.role) {
      case Role.Admin:
        return this.adminRegistrationApiService.updateRegistrationDetails$(data);
      case Role.PaOrMsp:
      case Role.Sido:
        return this.accountRegistrationApiService.updateRegistrationDetails$(data);
    }
  }

  getContactDetails$(accountId: number, contactId: number) {
    switch (this.roleService.role) {
      case Role.Admin:
        return this.adminRegistrationApiService.getContactDetails$(accountId, contactId);
      case Role.PaOrMsp:
      case Role.Sido:
        return this.accountRegistrationApiService.getContactDetails$(accountId, contactId);
    }
  }

  updateContactDetails$(data: AccountContactUpdate) {
    switch (this.roleService.role) {
      case Role.Admin:
        return this.adminRegistrationApiService.updateContactDetails$(data);
      case Role.PaOrMsp:
      case Role.Sido:
        return this.accountRegistrationApiService.updateContactDetails$(data);
    }
  }

  addContactDetails$(data: AccountContactAdd) {
    switch (this.roleService.role) {
      case Role.Admin:
        return this.adminRegistrationApiService.addContactDetails$(data);
      case Role.PaOrMsp:
      case Role.Sido:
        return this.accountRegistrationApiService.addContactDetails$(data);
    }
  }

  updateContactStatus$(accountId: number, contactId: number, active: boolean) {
    switch (this.roleService.role) {
      case Role.Admin:
        return this.adminRegistrationApiService.updateContactStatus$(accountId, contactId, active);
      case Role.PaOrMsp:
      case Role.Sido:
        return this.accountRegistrationApiService.updateContactStatus$(accountId, contactId, active);
    }
  }

  setContactAsPrimary$(accountId: number, contactId: number) {
    switch (this.roleService.role) {
      case Role.Admin:
        return this.adminRegistrationApiService.setContactAsPrimary$(accountId, contactId);
      case Role.PaOrMsp:
      case Role.Sido:
        return this.accountRegistrationApiService.setContactAsPrimary$(accountId, contactId);
    }
  }
}
